import { render, staticRenderFns } from "./cp-content-card.vue?vue&type=template&id=7724578c&scoped=true"
import script from "./cp-content-card.ts?vue&type=script&lang=ts&external"
export * from "./cp-content-card.ts?vue&type=script&lang=ts&external"
import style0 from "./cp-content-card.scss?vue&type=style&index=0&id=7724578c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724578c",
  null
  
)

export default component.exports